import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import {
    setUserAccessToken,
    changeWorkspace,
    errorNotification,
    loginUserSuccessful,
} from "../../store/actions";
import ConsentModal from "./ConsentModal";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL_AZURE_CALLBACK } from "src/common/constants";
import {
    LOCAL_STORAGE_KEY_ACCESS_TOKEN,
} from "../../services/constants/LocalStorage";
import UrlUtils from "src/services/utils/UrlUtils";
import UserUtils from "src/services/utils/UserUtils";

const AzureCallback = ({
    t,

    errorNotification,
    setUserAccessToken,
    loginUserSuccessful,
    changeWorkspace,
    history
}) => {   
    const [ message, setMessage ] = useState("");
    const [ consentData, setConsentData ] = useState(null);
    const [ profile, setProfile ] = useState(null);

    const urlUtils = new UrlUtils();
    const userUtils = new UserUtils();

    const setWorkspace = (profileData) => {
        const workspace = userUtils.getWorkspace(profileData);
        changeWorkspace(workspace);
    }

    const handleAfterLogin = () => {
        const {data, token} = profile;

        localStorage.setItem(LOCAL_STORAGE_KEY_ACCESS_TOKEN, token);
        localStorage.setItem("org", urlUtils.getOrganizationName());
        localStorage.setItem("azure", true);

        setUserAccessToken(token);

        loginUserSuccessful({
            ...data,
            needExchange: false,
            tempToken: token,
        });

        setWorkspace(data);

        history.push(userUtils.getUserStartPageRoute(data));
    }

    const handleCallback = ({
        accessToken,
        state
    }) => {
        document.cookie = `PHPSESSID=${state}`;
        
        axios.post(
            API_URL_AZURE_CALLBACK,
            {
                accessToken,
                state,
                code : accessToken,
                organizationId : Number.parseInt(urlUtils.getOrganizationId())
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true
            }
        )
        .then((res) => {
            setMessage('Redirecting');
            const {
                token,
                profile
            } = res.data?.data || {};

            setProfile({
                data: profile,
                token: token
            });
        })
        .catch((err) => {
            if (err.response) {
                const data = err.response.data;

                setMessage(
                    typeof data.message === "object"
                    ? JSON.stringify(data.message)
                    : data.message || data.title || data.error
                )

                errorNotification({
                    code: data.error || "unknown_error",
                    message: t(
                        typeof data.message === "object"
                        ? JSON.stringify(data.message)
                        : data.message || data.title || data.error
                    )
                });
            }
        });
    }

    useEffect(() => {
        if(profile){
            if(!profile.data.consentStatus){
                setConsentData({
                    token: profile.token
                });
            }
            else{
                handleAfterLogin();
            }
        }
    }, [ profile ]);

    useEffect(() => {
        const hashParams = new URLSearchParams((new URL(window.location.href)).search);
        const accessToken = hashParams.get("code");

        if (accessToken) {
            const sessionState = hashParams.get("session_state");
            const state = hashParams.get("state");
            handleCallback({
                accessToken, 
                state, 
                sessionState
            });
          }
    }, []);

    return (
        <div>
            <h1 className="mb-5">
                {
                    message ? t(message) : t("Please wait")
                }
            </h1>
            <ConsentModal
                modalData={consentData}
                toggleModal={() => setConsentData(null)}
                consentAccepted={handleAfterLogin}
            />
        </div>
    )
};


export default withNamespaces()(
    withRouter(
        connect(null, {
            loginUserSuccessful,
            setUserAccessToken,
            changeWorkspace,
            errorNotification
        })(AzureCallback)
    )
);